import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttp } from '../../core/classes/abstract-http';
import { environment } from '../../../environments/environment';

@Injectable()
export class GetCurrentFilialService extends AbstractHttp {

  constructor(http: HttpClient) {
    const url = `${environment.ENTORNO}${environment.SessionService.URL}${environment.SessionService.ENDPOINT.GetCurrentFilial}`;
    super(http, url);
  }
}
